import React from "react";

const SvgUpravit = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <style>{".Upravit_svg__st4{display:none;fill:#6afff8}"}</style>
    <g id="Upravit_svg__Obecn\xE9_ikony">
      <path
        d="M127.5 31.6c-3.5-2.5-8.2-2.6-10.5.8l-10.7 15.3c-2.3 3.3-.6 7.7 2.9 10.2l22.7 15.9c3.5 2.5 8.2 2.6 10.6-.7l10.7-15.3c2.3-3.3.6-7.7-2.9-10.2l-22.8-16zm-24.4 26.8c-1.6-1.2-3.9-.8-5.1.9l-45.7 65.2c-.8 1.1-1.3 2.3-1.5 3.6-1.3.4-2.4 1.5-2.5 3.1l-2.4 35.2c-.2 2.7 2.6 4.7 5.1 3.6 1-.4 31.2-13.8 32.2-14.3 1.5-.6 2.1-2 2.1-3.4 1.1-.7 2.1-1.6 2.9-2.7l45.6-64.9c1.2-1.6.8-3.9-.9-5.1-1.6-1.2-3.9-.8-5.1.9l-45.6 64.9c-.7 1.1-2.1 1.3-3.1.7l-20.3-14.2c-1-.7-1.2-2.1-.4-3.1L104 63.5c1.2-1.7.8-4-.9-5.1zm-48 79.7l19.3 13.5c-4.7 2.1-10.4 4.6-15.6 6.9l-4.8-3.4 1.1-17z"
        id="Upravit_svg__Upravit"
      />
    </g>
    <g id="Upravit_svg__Bo\u010Dn\xED_menu">
      <circle className="Upravit_svg__st4" cx={-120} cy={100} r={126.4} />
      <circle className="Upravit_svg__st4" cx={100} cy={100} r={126.4} />
      <circle className="Upravit_svg__st4" cx={320} cy={100} r={126.4} />
    </g>
  </svg>
);

export default SvgUpravit;

